// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
interface FieldErrorMap {
  [key: string]: string[]
}


interface PydanticValidationError {
  detail: {loc: string[], type: string}[]
}


export class ValidationFailure extends Error {
  public fieldErrors: FieldErrorMap

  constructor(errors: FieldErrorMap | PydanticValidationError) {
    super()
    this.fieldErrors = {}
    if (errors.detail === undefined) {
      this.fieldErrors = errors as FieldErrorMap
    } else {
      //@ts-ignore
      const errorList: {loc: string[], type: string}[] = errors.detail
      for (const error of errorList) {
        if (error.loc.length !== 2) {
          continue
        }
        const fieldName = error.loc[1]
        if (!this.fieldErrors[fieldName]) {
          this.fieldErrors[fieldName] = []
        }
        this.fieldErrors[fieldName].push(error.type)
      }
    }
  }
}